import React, { useState } from 'react';
import Modal from 'react-modal';
import Dialog from 'components/Dialog';
import Button from 'components/Button';
import Link from 'components/Link';
import BoxBody from 'components/BoxBody';
import Text from 'components/Text';

export type Props = {
  children: (props: { onClick: () => void }) => React.ReactElement;
};

export default function FreeAnnouncementRateLimit(props: Props) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      {props.children({ onClick: () => setIsOpen((open) => !open) })}
      <Modal isOpen={isOpen}>
        <Dialog
          title="Your district has reached its weekly usage limit"
          onRequestHide={() => setIsOpen(false)}
          size="xxsmall"
        >
          <BoxBody>
            <Text color="graphite" element="p" align="left">
              Announcements will be available again next week when the limit resets. You can still{' '}
              <Link href="/classes/r/messages">send individual messages</Link>.
            </Text>

            <Text color="graphite" element="p" align="left">
              Announcements without usage limits are available for districts with{' '}
              <Link href="https://www.remind.com/hub">Remind Hub</Link>.
            </Text>

            <Text color="graphite" element="p" align="left">
              If you have questions or concerns, please reach out to your district leadership.
            </Text>

            <Button full color="mascot" onClick={() => setIsOpen(false)}>
              Done
            </Button>
          </BoxBody>
        </Dialog>
      </Modal>
    </>
  );
}
